import CoachCardsAnimation from './CoachCardsAnimation'
export default CoachCardsAnimation
